"use client";
import * as React from "react";
const SvgFileUploadOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14 11v3H2v-3H0v3c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2v-3zM3 5l1.41 1.41L7 3.83V12h2V3.83l2.59 2.58L13 5 8 0z" }));
export {
  SvgFileUploadOutlined as default
};
